<template>
  <!-- 套餐商品样式 -->
  <div class="productsPackage-wrap">
    <div class="_left">
      <!-- 标题以及价格部分 -->
      <div class="title-wrap">
        <h3 class="title">{{ data.contentName }}</h3>
        <div class="price-wrap">
          <div class="price-item">
            <div class="price-item-label">{{ shopType === 1 ? '商品价格:' : '套餐价:' }}</div>
            <div class="price-item-txt txt">{{ data.price }}</div>
          </div>
          <div class="price-item">
            <div class="price-item-label">划线价：</div>
            <div class="price-item-txt txt">{{ data.originPrice }}</div>
          </div>
          <div class="price-item" v-if="shopType === 1">
            <div class="price-item-label">skuID：</div>
            <div class="price-item-txt">{{ data.skuId || '--'}}</div>
          </div>
          <div class="price-item" v-if="shopType === 1">
            <div class="price-item-label">spuID：</div>
            <div class="price-item-txt">{{ data.spuId || '--' }}</div>
          </div>
        </div>
      </div>
      <div class="content-box" v-if="shopType === 2">
        <div
          v-for="(item, index) in data.skus"
          :key="index"
          class="content-item"
        >
          <div class="item-box">
            <div class="sku-id-box">
              <span>skuID：</span>
              <span>{{ item.skuId || '--' }}</span>
            </div>
            <div>
              <span>spuID：</span>
              <span>{{ item.spuId || '--' }}</span>
            </div>
          </div>
          <div class="item-box">
            <div v-if="item.logo" class="good-item-img">
              <img :src="item.logo" alt="" />
            </div>
            <div class="item-info">
              <div class="info-title">
                {{ item.skuName }}
              </div>
              <div class="info-specs">
                <div>
                  {{ item.specs[0].specValue + item.specs[0].specUnit }}
                </div>
                <div>X{{ item.num }}</div>
              </div>
              <div class="info-price">
                <div class="price-dis">￥{{ item.price }}</div>
                <div class="price-originPrice">￥{{ item.originPrice }}</div>
              </div>
            </div>
          </div>
          <div class="item-box" v-if="item.laborCost">
            <div v-if="item.logo" class="good-item-img"></div>
            <div class="item-info">
              <div class="info-title">
                {{ item.laborCost.skuName }}
              </div>
              <div class="info-specs">
                <div>
                  {{ item.laborCost.specValue + item.laborCost.specUnit }}
                </div>
                <div>X{{ item.laborCost.num }}</div>
              </div>
              <div class="info-price">
                <div class="price-dis">￥{{ item.laborCost.laborCost }}</div>
                <div class="price-originPrice">
                  ￥{{ item.laborCost.originPrice }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-box"  v-else>
        <div class="content-item">
          <div class="item-box">
            <div v-if="data.logo" class="good-item-img">
              <img :src="data.logo" alt="" />
            </div>
            <div class="item-info">
              <div class="info-title">
                {{ data.skuName }}
              </div>
              <div class="info-specs" v-if="data.specs && data.specs.length">
                <div>
                  {{ data.specs[0].specValue + data.specs[0].specUnit }}
                </div>
                <div>X{{ data.num }}</div>
              </div>
              <div class="info-price">
                <div class="price-dis">￥{{ data.price }}</div>
                <div class="price-originPrice">￥{{ data.originPrice }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 工时信息 -->
      <div class="content-wrap">
        <div v-if="data.laborCost" class="laborCost mt16">
          <div class="good-item-info">
            <div class="info-title">{{ data.laborCost.skuName }}</div>
            <div class="info-specs">
              <div class="specs-unity">
                <span>{{
                  data.laborCost.specValue + data.laborCost.specUnit
                }}</span>
              </div>
              <div class="specs-num">X{{ data.laborCost.num }}</div>
            </div>
            <div class="info-price">
              <div class="price-dis">￥{{ data.laborCost.laborCost }}</div>
              <div class="price-originPrice">
                ￥{{ data.laborCost.originPrice }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="data.laborCost" class="item-labor_cost">
          共计工时费：{{ data.laborCost.amount }}元
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    shopType: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>
.productsPackage-wrap {
  display: flex;
  padding: 16px;
  width: 100%;
  min-width: 0;
  color: #333;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid #333;
  margin: 10px 0;
  ._left {
    flex: 1;
    min-width: 0;
    .title-wrap {
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }
      // 价格模块
      .price-wrap {
        display: flex;
        overflow: hidden;
        .price-item {
          display: flex;
          min-width: 0;
          margin-right: 16px;
          .price-item-label {
            line-height: 32px;
          }
          .price-item-txt {
            line-height: 32px;
            &.txt {
              width: auto !important;
            }
          }
        }
      }
    }
    .content-box {
      .content-item {
        margin-bottom: 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid #333;
        &:last-child {
          border: none;
        }
        // 每一次
        .item-box {
          display: flex;
          margin-top: 10px;
          .sku-id-box {
            margin-right: 20px;
          }
          // 图片
          .good-item-img {
            width: 100px;
            height: 100px;
            overflow: hidden;
            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .item-info {
            margin-left: 10px;
            .info-specs {
              display: flex;
              justify-content: space-between;
              margin: 10px 0;
            }
            .info-price {
              display: flex;
              font-size: 16px;
              .price-originPrice {
                margin-left: 10px;
                text-decoration: line-through;
              }
            }
          }
        }
      }
    }

    .laborCost {
      display: flex;
      border-bottom: 1px solid #333;
      border-top: 1px solid #333;
      margin-bottom: 10px;
      padding-bottom: 10px;
      .good-item-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 10px;
        min-width: 0;
      }
      .info-title {
        font-size: 14px;
        line-height: 2;
        color: #666;
      }
      .info-specs {
        display: flex;
        .specs-unity {
          flex: 1;
          min-width: 0;
        }
      }
      .info-price {
        display: flex;
        font-size: 16px;
        .price-originPrice {
          margin-left: 10px;
          text-decoration: line-through;
        }
      }
    }
  }
}
</style>
